import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import { Column } from '@nirvana/shared/dtos/types/shared/filters';
import {
  GetRowsRequest,
  GetSummaryRequest,
  GetSummaryResponse,
  SetFiltersRequest,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../grid/types/common';
import { ColumnKeys } from '../types';
import { convertGridFiltersToExtJsFilters } from 'apps/webcomponents/src/grid/utils/filters';
import { handleComplexEnumFilter } from 'apps/webcomponents/src/riskManagement/common/utils';

export class BreachPathAppGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  response;
  companyConsoleResponse;
  dependencies;

  constructor(dependencies) {
    super();
    this.dependencies = dependencies;
  }

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    let filters: any[] = convertGridFiltersToExtJsFilters(request.filters);

    const complexEnumFilterColumns = [ColumnKeys.RESOURCE_NAME, ColumnKeys.CLOUD_ACCOUNT];
    filters = handleComplexEnumFilter(complexEnumFilterColumns, filters);

    if (!this.response) {
      this.response = await this.dependencies.api.clients.BreachPathIssues.readRecords(request, filters).toPromise();
    }

    const summary: any = {
      summary: `${this.response.total} items`,
      numItems: this.response.total,
    };

    if (this.response.extraDetails) {
      summary.extraDetails = this.response.extraDetails;
    }

    return summary;
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<any> {
    if (!this.response) {
      return { rawEvents: [] };
    }

    // this.response should be already fetched from getSummary above.
    const response = this.response;

    this.response = null;

    return { rawEvents: response.data ?? [] };
  }

  async updateSettings(params: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    return {};
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    return {};
  }
}
